import { useMutation } from '@tanstack/react-query'
import { httpClient } from './httpClient'

export const useRegister = () =>
  useMutation((payload) => httpClient.post('/auth/register', payload))
